/**
 * Formatea un nombre para que cada palabra comience con mayúscula y el resto sea minúscula.
 * Ejemplo: "REYNA ESPERANZA" -> "Reyna Esperanza"
 * @param {string} name - El nombre a formatear
 * @returns {string} - El nombre formateado
 */
export const capitalizeName = (name) => {
  if (!name) return "";
  
  // Dividir por espacios, filtrar vacíos, formatear cada palabra y volver a unir
  return name
    .toLowerCase()
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
